<div mat-dialog-content class="modal-container" *ngIf="!viewRegister">
  <button type="button" class="close" (click)="closeModal()">
    <i class="fa-solid fa-xmark"></i>
  </button>
  <div>
    <div class="text-center titulos" style="margin-bottom: 20px">
      <h2 translate>
        components.ingreso.Inicia sesion
      </h2>
    </div>

    <form [formGroup]="loginForm">
      <div class="margin-bottom">
        <input
          id="email"
          class="form-control"
          formControlName="email"
          type="email"
          autocomplete="email"
          placeholder="Email"
        />
        <small
          *ngIf="loginForm.controls.email.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.registration.emailRequired
        </small>
      </div>
      <div class="margin-bottom">
        <div class="input-group no-padding">
          <input
            id="password"
            class="form-control"
            [type]="showRepeatPassword ? 'password' : 'text'"
            formControlName="password"
            placeholder="{{ 'components.encubierto.password' | translate }}"
          />
          <button
            class="input-group-text"
            id="btnGroupAddonRepeat2"
            (click)="showRepeatPassword = !showRepeatPassword"
          >
            <i
              [class]="showRepeatPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
            ></i>
          </button>
        </div>
        <small
          *ngIf="loginForm.controls.password.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.registration.passwordValidationwordRequired
        </small>
        <small
          *ngIf="submitted && invalidPassword"
          class="text-danger no-padding"
          translate
        >
           components.encubierto.incorrectPassword
        </small>
      </div>
      <div class="margin-bottom" style="margin-top: 25px;">
        <a
          class="no-padding"
          [routerLink]="[
            '/' + translateService.currentLang + '/recover-password'
          ]"
          translate
          (click)="closeModal()"
          > components.encubierto.forgotPassword</a
        >
      </div>

      <div class="margin-bottom">
        <button
          class="btn btn-block buttons btn-blue"
          [disabled]="disabledSubmit"
          (click)="login()"
          translate
        >
          components.ingreso.Inicia sesion
        </button>
        <div class="d-flex justify-content-center" style="margin-top: 15px;" *ngIf="isLoading">
          <mat-progress-spinner
            mode="indeterminate"
            color="primary"
            [diameter]="25"
          ></mat-progress-spinner>
        </div>
      </div>
    </form>
    <div class="text-center">
      <em
        class="fas fa-circle-o-notch ml-1 fa-spin fa-2x"
        enabled
        [hidden]="!isLodingModal"
      ></em>
    </div>
    <div style="display: flex; justify-content: center">
      <div class="linea" style="margin-right: 6px"></div>
      <div class="leyenda" translate>components.ingreso.o continua con</div>
      <div class="linea" style="margin-left: 6px"></div>
    </div>
    <div
      class="row margin-bottom abs-center"
      style="display: flex; justify-content: center"
    >
      <i
        class="fab fa-google fa-2x social-icons"
        (click)="googleRequest.requestAccessToken()"
      ></i>
      &nbsp;&nbsp;
      <i
        class="fab fa-facebook fa-2x social-icons"
        (click)="signUpWithFB()"
      ></i>
    </div>

    <div class="margin-bottom text-center">
      <h4 translate>
        components.ingreso.no tienes cuenta
        <a
          class="link"
          (click)="viewRegister = true; createFormRegister()"
          translate
          >components.ingreso.registrate</a
        >
      </h4>
    </div>
  </div>
</div>

<div mat-dialog-content class="modal-container" *ngIf="viewRegister">
  <button type="button" class="close" (click)="closeModal()">
    <i class="fa-solid fa-xmark"></i>
  </button>
  <div>
    <div class="titulos text-center" style="margin-bottom: 25px">
      <h2 translate>components.ingreso.registrate</h2>
    </div>

    <form [formGroup]="registerForm">
      <div class="margin-bottom">
        <input
          id="nombre"
          class="form-control"
          formControlName="first_name"
          type="text"
          placeholder="{{ 'Nombre' | translate }}"
        />
        <small
          *ngIf="registerForm.controls.first_name.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.registration.nameRequired
        </small>
        <small
          *ngIf="registerForm.controls.first_name.errors?.maxlength"
          class="text-danger no-padding"
          translate
        >
          components.registration.nameMaxChars
        </small>
        <small
          *ngIf="registerForm.controls.first_name.errors?.pattern"
          class="text-danger no-padding"
          translate
        >
          components.registration.noSpecialChars
        </small>
      </div>
      <div class="margin-bottom">
        <input
          id="apellido"
          class="form-control"
          formControlName="last_name"
          type="text"
          placeholder="{{ 'Apellido' | translate }}"
        />
        <small
          *ngIf="registerForm.controls.last_name.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.registration.surnameRequired
        </small>
        <small
          *ngIf="registerForm.controls.last_name.errors?.maxlength"
          class="text-danger no-padding"
          translate
        >
          components.registration.surnameMaxChars
        </small>
        <small
          *ngIf="registerForm.controls.last_name.errors?.pattern"
          class="text-danger no-padding"
          translate
        >
          components.registration.surnameNoSpecialChars
        </small>
      </div>
      <div class="margin-bottom">
        <input
          id="telefono"
          class="form-control"
          formControlName="phone"
          type="text"
          appMaxLength
          [maxLength]="12"
          placeholder="{{ 'Teléfono' | translate }}"
        />
        <small
          *ngIf="registerForm.controls.phone.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.oferta.El campo telefono es obligatorio
        </small>

        <small
          *ngIf="registerForm.controls.phone.errors?.pattern"
          class="text-danger no-padding"
          translate
        >
          components.registration.onlyNumbers
        </small>
      </div>
      <div class="margin-bottom">
        <input
          id="email"
          class="form-control"
          formControlName="email"
          type="email"
          autocomplete="email"
          placeholder="Email"
        />
        <small
          *ngIf="registerForm.controls.email.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.registration.emailRequired
        </small>
        <small
          *ngIf="registerForm.controls.email.errors?.pattern"
          class="text-danger no-padding"
          translate
        >
          components.registration.invalidEmailFormat
        </small>
        <small
          *ngIf="emailExists && submitted"
          class="text-danger no-padding"
          translate
        >
          components.registration.emailAlreadyInUse
        </small>
      </div>
      <div class="margin-bottom">
        <div class="input-group no-padding">
          <input
            id="password"
            formControlName="password"
            class="form-control"
            [type]="showRepeatPassword ? 'password' : 'text'"
            placeholder="{{
              'components.encubierto.password' | translate
            }}"
          />
          <button
            class="input-group-text"
            id="btnGroupAddonRepeat2"
            (click)="showRepeatPassword = !showRepeatPassword"
          >
            <i
              [class]="
                showRepeatPassword ? 'fas fa-eye' : 'fas fa-eye-slash'
              "
            ></i>
          </button>
        </div>
        <small
          *ngIf="registerForm.controls.password.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.registration.passwordValidationwordRequired
        </small>
        <small
          *ngIf="registerForm.controls.password.errors?.pattern"
          class="text-danger no-padding"
          translate
        >
          components.registration.passwordValidation
        </small>
      </div>
      <div class="margin-bottom-pass">
        <div class="input-group no-padding">
          <input
            id="password"
            formControlName="repeat_password"
            class="form-control"
            [type]="showRepeatPassword ? 'password' : 'text'"
            placeholder="{{
              'components.encubierto.confirmPassword' | translate
            }}"
          />
          <button
            class="input-group-text"
            id="btnGroupAddonRepeat2"
            (click)="showRepeatPassword = !showRepeatPassword"
          >
            <i
              [class]="
                showRepeatPassword ? 'fas fa-eye' : 'fas fa-eye-slash'
              "
            ></i>
          </button>
        </div>
        <small
          *ngIf="registerForm.controls.repeat_password.errors?.required && submitted"
          class="text-danger no-padding"
          translate
        >
          components.oferta.Debes ingresar la contraseña nuevamente
        </small>
        <small
          *ngIf="registerForm.controls.repeat_password.errors?.mustMatch"
          class="text-danger no-padding"
          translate
        >
          components.registration.passwordsDoNotMatch
        </small>
      </div>
      <p translate>
        components.registration.byClickingOn
        <b><i translate>components.registration.signUp</i></b>
        components.registration.acceptThe
        <a
          [routerLink]="[
            '/' + translateService.currentLang + '/terminos-condiciones'
          ]"
          placement="bottom"
          target="_blank"
          translate
        >
          components.registration.termsAndConditions
        </a>
        ,
        <a
          [routerLink]="[
            '/' + translateService.currentLang + '/politica-de-privacidad'
          ]"
          placement="bottom"
          target="_blank"
          translate
        >
          components.registration.privacyPolicies</a
        >
        components.registration.ofInviertisAndUnderstand
        <a
          [routerLink]="[
            '/' + translateService.currentLang + '/aviso-legal'
          ]"
          placement="bottom"
          target="_blank"
          translate
        >
          components.registration.relationshipWithInviertis</a
        >
      </p>
      <mat-checkbox formControlName="acceptNotifications" [color]="'primary'">
          <span class="check" translate>components.registration.wantReceiveInfo</span>
        </mat-checkbox>
      <div class="margin-bottom" style="margin-top: 15px;">
        <button
          id="CTA-registro-ofertar"
          class="btn btn-block buttons registro-modal-oferta btn-blue"
          (click)="register()"
          translate
        >
          components.registration.signUp
        </button>
        <div class="d-flex justify-content-center" style="margin-top: 15px;" *ngIf="isLoading">
          <mat-progress-spinner
            mode="indeterminate"
            color="primary"
            [diameter]="25"
          ></mat-progress-spinner>
        </div>
      </div>
    </form>

    <div class="text-center">
      <em
        class="fas fa-circle-o-notch ml-1 fa-spin fa-2x"
        enabled
        [hidden]="!isLodingModal"
      ></em>
    </div>

    <div style="display: flex; justify-content: center">
      <div class="linea" style="margin-right: 6px"></div>
      <div class="leyenda" translate>components.ingreso.o registrate con</div>
      <div class="linea" style="margin-left: 6px"></div>
    </div>

    <div class="row margin-bottom abs-center" style="margin-bottom: 2em">
      <i
        class="fab fa-google fa-2x social-icons"
        (click)="googleRequest.requestAccessToken()"
      ></i>
      &nbsp;&nbsp;
      <i
        class="fab fa-facebook fa-2x social-icons"
        (click)="signUpWithFB()"
      ></i>
    </div>

    <div class="margin-bottom text-center">
      <h4 translate>
        components.ingreso.ya tienes cuenta
        <a class="link" (click)="viewRegister = false" translate
          >components.ingreso.Inicia sesion</a
        >
      </h4>
    </div>
  </div>
</div>
